// Bundle dependencies

// no polyfills here, the must be bundled in ns.wow Core

// Bundle Places module

import Plugin from './Plugin';


export default {

  version: () => {
    return NSContext.plugins.dlc.version;
  }

};


// Initialize on document ready


document.addEventListener("DOMContentLoaded", function () {
  Plugin.init();
}); 